import { Container, Col, Row } from "react-bootstrap";
import { useState } from "react";
import ServicesBio from "./components/servicesBio"
import { useParams, useNavigate } from "react-router-dom";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { MainModal } from "@/components";
import { useDeleteServiceMutation } from "../../features/service/serviceApiSlice";

const ServicesProfile = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [show, setShow] = useState(0);
  const [deleteService] = useDeleteServiceMutation();
  const handleClose = () => setShow(0);
  const Deletedata = async () => {
    try {
      const response = await deleteService(id).unwrap();
      if (response?.success) {
        SuccessNotify("Delete Service SuccessFully")
      }
      setTimeout(() => {
        setShow(0)
        setTimeout(() => {
          navigate("/dashboard")
        }, 4000)
      })
    } catch (error) {
      FailedNotify()
    }
  }
  return (
    <Container>
      <Col md={10} lg={12} xl={11} className="screenHeight p-2 mx-auto">
        {show === 1 && (
          <MainModal
          variant="deleteModal"
            show={show}
            title="Service"
            handleClose={handleClose}
            handledelete={Deletedata}
          />
        )}
        <Row className="d-flex justify-content-center">
          <Col
            md={12}
            lg={12}
            className="p-2 p-md-4 rounded"
            style={{ backgroundColor: "#fafafa" }}
          >
            <ServicesBio id={id} setShow={setShow} />
          </Col>
        </Row>
      </Col>
    </Container>
  )
}
export default ServicesProfile;